module.exports = __webpack_public_path__ + "static/media/dollar.689fc7f0.svg";